import { action, extendObservable } from 'mobx'

class Segment {
  constructor (segmentData) {
    extendObservable(this, {
      ...segmentData,
      expanded: true,
      loading: false
    })
  }

  toggle = action(() => {
    this.expanded = !this.expanded
  })
}

export default Segment
